export default __webpack_public_path__ + "static/media/signature-icon.3163bd04.svg";